import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, InputNumber } from 'antd';
import {toggle4DCommissionUpdate} from '../../redux/actions/agent/toggle4DCommissionUpdate';
import { update4DCommission } from '../../redux/actions/agent/updateAgent';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
};

class Update4DCommissionModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate({
            id:this.props.agent?.id,
            commission:values.fourDCommission
        },
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
            this.form.current.resetFields();
            this.props.onClose();
        }
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update FourD Commission"
                key={this.props.agent?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-4dc-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                {...layout}
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-4dc-form"
                    name="basic"
                    initialValues={{
                        fourDCommission:this.props.agent?.fourDCommission,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="fourDCommission"
                        label="Commission"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.agent.update4dCommissionVisible,
    loading: state.agent.loading,
    token: state.auth.token,
    error: state.agent.error,
    message: state.agent.message,
    agent:state.agent.one
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (obj, token) => dispatch(update4DCommission(obj, token)),
    onClose: () => dispatch(toggle4DCommissionUpdate()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Update4DCommissionModal);